<template>
    <nav class="navbar navbar-dark bg-primary py-3 navbar_top">
            <div class="text-center mx-auto" href="#"> 
                <img src="../assets/img/person.svg" alt="" width="46" height="46" class="d-inline-block align-text-top rounded-circle border border-2 border-white">
                <div class="pt-4">
                    <div class="h2 text-white">{{ officer_name }}</div>  
                </div>
                <div class="text-white"><a class="text-white" @click="logout">ออกจากระบบ</a> </div>
            </div>
    </nav>
</template>

<script>
export default {
    data () {
        return {
            officer_name: localStorage.getItem('officer_name'),
        }
    },
    methods: {
        logout() {
            localStorage.removeItem('officer_id')
            localStorage.removeItem('device_id')
            this.$router.push('/login')
        }
    }
}
</script>

<style scoped>
.navbar_top{
    height: 200px !important;
    border-radius: 0 0 40px 40px !important;
}
</style>